import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { useBackToList } from '@/components/app/use-back-to-list'
import { ShearingCertificateDetailContainer } from '@/components/screens/shearing/shearing-certificate-detail-container'

export const Route = createFileRoute('/t/$tenant_id/shearing_certificates/$shearing_certificate_id')({
  component: Page,
})

function Page() {
  const { tenant_id: tenantId, shearing_certificate_id: certificateId } = Route.useParams()
  const navigate = useNavigate()
  const backToList = useBackToList(() => {
    void navigate({ to: '/t/$tenant_id/shearing_certificates', params: { tenant_id: tenantId } })
  })
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        <ShearingCertificateDetailContainer
          key={JSON.stringify([tenantId, certificateId])}
          certificateId={certificateId}
          onBack={backToList}
        />
      </main>
    </div>
  )
}
